import { isDefined } from '@/utils/assertions';
import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import type { ExternalFilterDate, RootCashTransferState } from './model';

export const cashTransferSlice = createSlice({
  name: 'cashTransfer',
  initialState: { rootDependentUIState: {} } as RootCashTransferState,

  reducers: {
    dateRangeChanged: (
      state,
      {
        payload: { rootId, dateRange },
      }: PayloadAction<{ rootId: string; dateRange: ExternalFilterDate }>,
    ) => {
      if (isDefined(state.rootDependentUIState?.[rootId]?.externalFilters)) {
        state.rootDependentUIState[rootId].externalFilters.dateRange = dateRange;
      } else {
        state.rootDependentUIState[rootId] = { externalFilters: { dateRange } };
      }
    },
  },

  selectors: {
    externalFilterDateRange: (state, rootId: string) =>
      state.rootDependentUIState?.[rootId]?.externalFilters?.dateRange,
  },
});

export const cashTransferActions = cashTransferSlice.actions;

export const { externalFilterDateRange } = cashTransferSlice.selectors;
